module.exports = __webpack_public_path__ + "img/Mask Group@2x.a48432b3.png";